import AppointmentShow from './AppointmentShow';

export default AppointmentShow;
